// Prod_US words, US English only (Prod_US is a US product). Copied from the signed-off
// prototype SeniorLife-Mobility-Prod_US-v1.0.html. Words the app already has (test
// screens, How to test, upload buttons) come from src/assets/locale/*.json as usual.
export const PROD_US_TEXT = {
  brand: "SeniorLife.AI",
  tagline: "Aging Smarter",
  product: "30-Second Mobility Check",
  free_first: "First check FREE",
  hero_alt: "A helper films an older woman walking toward the phone",
  wnote: "For wellness only. Not a medical test.",
  start_free: "Start your free check",
  have_acct: "Already checked? Sign in",
  sample_btn: "See a sample result",
  back: "Back",
  menu: "Menu",
  next: "Next",
  busy: "Please wait…",

  // Sign-in
  phone: "Mobile number",
  phone_req: "Enter a 10-digit mobile number.",
  send: "Text me a code",
  terms_line: "By continuing, you agree to the {terms} and {privacy}.",
  terms: "Terms of Service",
  privacy: "Privacy Policy",
  code_title: "Check your texts",
  code_sent: "We sent a 6-digit code to {mask}.",
  code_label: "Verification code",
  verify: "Verify",
  resend: "Resend code",
  change: "Use a different number",
  code_req: "Enter the 6-digit code.",
  code_wrong: "That code didn't work. Check your latest text.",
  code_locked: "Too many tries. Wait 15 minutes, then resend.",
  send_failed: "We couldn't send the code. Try again.",
  try_again: "Something went wrong. Try again.",

  // Who / About
  who_title: "Who is being checked?",
  who_me: "Me",
  who_other: "Someone I'm helping",
  who_agreed: "They agreed to this check.",
  who_note: "Your video is deleted after processing.",
  about_me: "About you",
  about_other: "About the person",
  about_why: "Used only for comparison.",
  fi: "First initial",
  li: "Last initial",
  err_init: "Enter one letter",
  bmonth: "Birth month",
  byear: "Birth year",
  month: "Month",
  year: "Year",
  height: "Height",
  feet: "Feet",
  inches: "Inches",
  ft: "ft",
  in: "in",
  sex: "Sex",
  male: "Male",
  female: "Female",
  err_birth: "Choose month and year",
  err_adult: "This check is for people 50 and older.",
  err_height: "Choose a height",
  err_height_range: "Height must be 4 ft 6 in to 7 ft 0 in.",
  err_sex: "Choose one",
  save_failed: "We couldn't save. Try again.",

  // Person page (Mobility Tests)
  credits: "{n} credits left",
  request_credits: "Request more credits",
  none_left: "Your free checks are used.",
  analyzing: "Analyzing your check",
  analyzing_sub: "This usually takes about a minute.",
  report_ready: "Your report is ready",
  check_failed:
    "We couldn't analyze the videos. No credits were used. Please record them again.",
  rc_q_title: "Request more credits",
  rc_q_sub: "Do you have a partner code?",
  rc_q_yes: "I have a partner code",
  rc_q_yes_desc: "Sign up at Inochi",
  rc_q_no: "No partner code",
  rc_q_no_desc: "Contact us",
  cancel: "Cancel",

  // Sit-to-Stand How to test, step 4 (upload at the end)
  sts_step4:
    "Tap “Next: TUG (Front)”. Both videos upload after the second test.",

  // Upload (both videos, after the second test)
  video_uploading: "Your test videos are uploading..",
  upload_count: "{current} of {total}",
  upload_alert: "Do not close the app during upload",
  cancel_upload_btn: "Cancel Upload",
  upload_success: "Your test videos uploaded successfully!",
  alert_info: "You will be notified shortly when the report is ready.",
  done: "Done",
  upload_failed:
    "The upload didn't finish. Check your connection and try again.",
  retry: "Try again",
  videos_missing:
    "The videos are no longer on this screen. Please record them again.",

  // Menu
  view_report: "View Recent Report",
  view_report_d: "Your latest results",
  sample_d: "5 checks over 5 months",
  m_privacy: "Privacy and data policy",
  m_privacy_d: "How we use your data",
  m_terms: "Terms of service",
  m_terms_d: "Rules for using the app",
  m_support: "Contact support",
  m_support_d: "Get help from our team",
  m_delete: "Delete my data",
  m_delete_d: "Removes your number, details and results",
  m_logout: "Logout",
  m_logout_d: "Stops notifications on this device",
  del_title: "Delete your data?",
  del_body:
    "This deletes your mobile number, the person's details and the results. You can't undo this.",
  del_btn: "Delete",
  del_done: "Your data was deleted",
  details: "Details",
  close: "Close",
  det_sec: "Profile",
  det_edit: "Edit",
  det_save: "Save",
  det_saved: "Saved",
  det_client_id: "Client ID",
  det_sl_id: "SeniorLife ID",
  det_born: "Born",
  det_added: "Added {date}",
};

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// "{n} credits left" -> "2 credits left"
export const fill = (text, values = {}) =>
  String(text).replace(/\{(\w+)\}/g, (all, key) =>
    key in values ? String(values[key]) : all,
  );

export const pt = (key, values) => fill(PROD_US_TEXT[key] ?? key, values);
